import KEY_CODES from '@dui/helpers/key-codes';

export default {
  data: () => ({
    vm: {
      isOpen: false,
    },
  }),
  beforeDestroy() {
    this.removeContextMenuEventListeners();
  },
  methods: {
    toggleOpen(openState) {
      if (typeof openState === 'boolean') {
        this.vm.isOpen = openState;
      }
      else {
        this.vm.isOpen = !this.vm.isOpen;
      }

      if (this.vm.isOpen) {
        this.addContextMenuEventListeners();
        return;
      }

      this.removeContextMenuEventListeners();
    },
    // Events
    addContextMenuEventListeners() {
      document.addEventListener('mousedown', this.windowClickPerformed);
      window.addEventListener('keydown', this.keyUpPerformed);
    },
    removeContextMenuEventListeners() {
      document.removeEventListener('mousedown', this.windowClickPerformed);
      window.removeEventListener('keydown', this.keyUpPerformed);
    },
    keyUpPerformed(ev) {
      if (ev.keyCode !== KEY_CODES.ESCAPE) {
        return;
      }

      this.toggleOpen(false);
    },
    windowClickPerformed(event) {
      if (this.$el.contains(event.target)){
        return;
      }

      this.toggleOpen(false);
    },
    // END Events
  },
};
